import { makeStyles } from 'tss-react/mui';
import { tableParentRow, teceoLightGray, teceoOrange } from '../../../../Theme';

export const useProductDetailsStyles = makeStyles()((theme) => ({
  selectedButtonRoot: {
    height: '28px',
    borderRadius: theme.spacing(2),
    border: `1.5px solid ${teceoOrange}`,
    backgroundColor: '#FFFFFF',
    flexShrink: 0,
  },
  buttonRoot: {
    height: '28px',
    borderRadius: theme.spacing(2),
    border: `0.5px solid ${teceoLightGray} `,
    backgroundColor: '#FFFFFF',
    flexShrink: 0,
  },
  containerSpacing: {
    padding: theme.spacing(3, 2, 3, 2),
  },
  scrollBar: {
    overflowY: 'scroll',
    overflowX: 'unset',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    '&::-webkit-scrollbar': {
      width: '0',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'none',
    },
  },
  productDetailsVariant: {
    fontSize: '16px',
  },
  skeleton: {
    backgroundColor: tableParentRow,
    borderRadius: '6px',
  },
  mobileNoWrapRoot: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    overflowX: 'auto',
    flexWrap: 'nowrap',
  },
  mobileMassActionContainer: {
    width: '100%',
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: 10,
  },
}));
